import { PageContainer } from "@/components/layout/PageContainer";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Calendar, Clock, Video } from "lucide-react";

export default function VideoConsultation() {
  return (
    <PageContainer>
      <div className="max-w-6xl mx-auto space-y-8">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-bold">Video Consultation</h1>
          <p className="text-xl text-gray-600">
            Schedule a video consultation with our technical team for personalized assistance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Calendar className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">Choose a Date</h2>
              <p className="text-gray-600">Select your preferred consultation date from our available slots.</p>
            </div>
          </Card>

          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Clock className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">Pick a Time</h2>
              <p className="text-gray-600">Choose a time that works best for your schedule.</p>
            </div>
          </Card>

          <Card className="p-6">
            <div className="space-y-4">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center">
                <Video className="w-6 h-6 text-primary" />
              </div>
              <h2 className="text-xl font-semibold">Join Meeting</h2>
              <p className="text-gray-600">Connect with our technical team through our secure video platform.</p>
            </div>
          </Card>
        </div>
      </div>
    </PageContainer>
  );
}